import {InputHTMLAttributes} from 'react'

import {CheckboxIcon} from 'src/components/icons'
import {animation} from 'src/styles'

import DisabledOverlay from './DisabledOverlay'

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  type?: 'checkbox'
}

const CheckboxInput = (props: Props) => {
  return (
    <label
      css={{
        position: 'relative',
        display: 'inline-block',
        width: 43,
        height: 43,
      }}
    >
      <input
        type="checkbox"
        {...props}
        css={{
          opacity: 0,
          width: 0,
          height: 0,

          '+ svg': {
            path: {
              transition: animation.selection('all'),
              strokeDashoffset: 40,
              strokeDasharray: 40,
            },
          },
          ':checked + svg': {
            path: {
              strokeDashoffset: 0,
              strokeDasharray: 40,
            },
          },
        }}
      />
      <CheckboxIcon
        css={{
          cursor: 'pointer',
          position: 'absolute',
          top: 0,
          left: 0,
        }}
      />
      {props.disabled && (
        // Semitranparent overlay that covers button when disabled.
        <DisabledOverlay />
      )}
    </label>
  )
}
export default CheckboxInput
